module.exports = __webpack_public_path__ + "0af5d249/img/question-icon.06c20c5d.svg";